import { render } from "./ErrorSpan.vue?vue&type=template&id=42e6fedb"
const script = {}

import "./ErrorSpan.vue?vue&type=style&index=0&id=42e6fedb&lang=css"

import exportComponent from "/home/runner/work/lms-v3-backend/lms-v3-backend/.vapor/build/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__